import PropTypes from 'prop-types';
import classNames from 'classnames';
import GlossaryText from '../GlossaryText';
import styles from './ManualSection.module.scss';

const ManualSection = ({
    anchor = '',
    title = '',
    hasLine = true,
    children = null,
}) => {
    return (
        <section
            id={anchor || undefined}
            className={classNames(styles['ManualSection'], {
                [styles['ManualSection--WithLine']]: hasLine,
            })}>
            {!!title && (
                <h2 className={styles['ManualSection__Title']}>
                    <GlossaryText text={title} />
                </h2>
            )}
            {children}
        </section>
    );
};

ManualSection.propTypes = {
    anchor: PropTypes.string,
    title: PropTypes.string,
    hasLine: PropTypes.bool,
    children: PropTypes.node,
};

export default ManualSection;
